<div class="content content-fixed w-full h-full">
  <div>
    <div class="container ">
      <!-- Page Header -->
      <div class="mb-3 w-full page-title-box d-sm-flex items-center justify-between">
        <h3 class="font-semibold w-1/2">Gaming Exclusion</h3>
        <!-- <input type="file" (change)="onFileChange($event)" accept=".csv" /> -->
        <div class="flex items-center justify-end space-x-2 w-1/2">
          <input type="text" placeholder="Search by ID, name, or email"
            class="border p-2 w-1/2 rounded-md focus:outline-none " (input)="onSearch($event.target.value)" />
          <button class="btn border-black border flex justify-center items-center" (click)="openAddmember()">
            <i data-feather="plus-circle" class="mr-1"></i> Candidate
          </button>
        </div>
      </div>

      <app-common-table [data]="tableBody" [displayedColumns]="columns">
        <ng-template #actionButtons let-row>
          <button class="btn edit mr-2" aria-label="Edit" (click)="onInvestigate(row)">
            <i class="fas fa-edit"></i>
          </button>
          <button class="btn delete" aria-label="Delete" (click)="onDelete(row)">
            <i class="fas fa-trash"></i>
          </button>
        </ng-template>
      </app-common-table>
      
      <div *ngIf="isLoading" class="w-screen h-screen fixed top-0 left-0 right-0 ">
        <app-spinner  class="loading-overlay"> Loading... </app-spinner>
      </div>



      <div class="pagination-controls flex justify-end my-4">
        <button class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          [disabled]="currentPage === 1" (click)="goToPage(1)">
          <i class="fa fa-fast-backward" aria-hidden="true"></i>
        </button>
        <button class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          [disabled]="currentPage === 1" (click)="prevPage()">
          <i class="fa fa-step-backward" aria-hidden="true"></i>
        </button>
        <div class="mx-2">Page {{ currentPage }} of {{ totalPageNo }}</div>
        <button class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5"
          (click)="nextPage()">
          <i class="fa fa-step-forward" aria-hidden="true"></i>
        </button>
        <button class="btn btn-sm btn-uppercase btn-default justify-center flex items-center mx-0.5" (click)="goto5()">
          <i class="fa fa-fast-forward" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>



  <div *ngIf="popUp && !DeletePopup" class="fixed inset-0 flex items-start index justify-center bg-black bg-opacity-50">
    <div class="bg-gray-200 py-1 mt-2 rounded-lg shadow-lg w-fit">
      <div class="w-full flex justify-between p-2">
        <h1 class="text-lg pl-2">{{ popupTitle }}</h1>
        <div type="button" class="close top-0 p-0" data-dismiss="modal" aria-label="Close" (click)="close()" #closeUser>
          <span aria-hidden="true">×</span>
        </div>
      </div>
      <div *ngIf="addUser" style="width: 1200px">
        <app-add-exclusion (response)="addSuccess($event)"></app-add-exclusion>
      </div>
      <div *ngIf="editUser && !selected" style="width: 1200px">
        <app-edit-exclusion [editFields]="editField" (updateParent)="onUpdateParent($event)"
          (closePopup)="closePopup()">
        </app-edit-exclusion>
      </div>
      <div *ngIf="selected && !editUser" style="width: 1200px">
        <div class="grid grid-cols-2 gap-1 mb-8 bg-white px-2">
          <div *ngFor="let field of inputfield2" class="p-1 flex flex-col justify-start">
            <label class="font-semibold w-full flex justify-start">{{ field.label }}:</label>
            <span class="border p-1 w-full rounded-sm text-left" style="background-color: #d1d5db">
              {{ selectedCandidate[field.name] || 'N/A' }}
            </span>
          </div>
        </div>
        <div class="w-full flex justify-center">
          <button (click)="closePopup()" class="cancel">Close</button>
        </div>
      </div>
      <app-status-messages [tosterMessage]="tosterMessage"></app-status-messages>
    </div>
  </div>
  <div *ngIf="popUp && DeletePopup" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg p-6 w-fit">
      <div class="w-full flex justify-between p-2">
        <h1 class="text-lg pl-2">{{ popupTitle }}</h1>
        <div type="button" class="close absolute top-0 right-0 p-2" data-dismiss="modal" aria-label="Close"
          (click)="close()" #closeUser>
          <span aria-hidden="true">×</span>
        </div>
      </div>
      <div *ngIf="DeletePopup" class="w-96 flex flex-col justify-center items-center">
        <div class="flex font-medium text-lg mb-2">
          <p>Candidate ID :</p>
          <p class="ml-1">{{ selectedCandidate.record_id }}</p>
        </div>
        <div class="flex mt-3 gap-2 mb-1">
          <button class="btn" (click)="close()">Cancel</button>
          <button class="btn btn-primary" (click)="onDelete(selectedCandidate)">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>